import PreviewGroup from '../vc-image/src/PreviewGroup';
import { computed, defineComponent } from 'vue';
import useConfigInject from '../_util/hooks/useConfigInject';
import RotateLeftOutlined from '@ant-design/icons-vue/RotateLeftOutlined';
import RotateRightOutlined from '@ant-design/icons-vue/RotateRightOutlined';
import ZoomInOutlined from '@ant-design/icons-vue/ZoomInOutlined';
import ZoomOutOutlined from '@ant-design/icons-vue/ZoomOutOutlined';
import CloseOutlined from '@ant-design/icons-vue/CloseOutlined';
import LeftOutlined from '@ant-design/icons-vue/LeftOutlined';
import RightOutlined from '@ant-design/icons-vue/RightOutlined';
export const icons = {
    rotateLeft: <RotateLeftOutlined />,
    rotateRight: <RotateRightOutlined />,
    zoomIn: <ZoomInOutlined />,
    zoomOut: <ZoomOutOutlined />,
    close: <CloseOutlined />,
    left: <LeftOutlined />,
    right: <RightOutlined />,
};
const InternalPreviewGroup = defineComponent({
    compatConfig: { MODE: 3 },
    name: 'OkkiImagePreviewGroup',
    inheritAttrs: false,
    props: {
        previewPrefixCls: String,
        preview: {
            type: [Boolean, Object],
            default: true,
        },
    },
    setup(props, { attrs, slots }) {
        const { getPrefixCls, getPopupContainer } = useConfigInject('image', props);
        const mergedPreview = computed(() => {
            const { preview } = props;
            if (preview === false) {
                return preview;
            }
            const _preview = typeof preview === 'object' ? preview : {};
            return {
                ..._preview,
                getContainer: _preview.getContainer || getPopupContainer.value,
            };
        });
        const prefixCls = computed(() => getPrefixCls('image-preview', props.previewPrefixCls));
        return () => {
            return (<PreviewGroup {...{ ...attrs, ...props }} icons={icons} preview={mergedPreview.value} previewPrefixCls={prefixCls.value} v-slots={slots}></PreviewGroup>);
        };
    },
});
export default InternalPreviewGroup;
